var BASWebServices;
(function (BASWebServices) {
    var ServiceListService = (function () {
        function ServiceListService(cmdiOptions) {
            this.cmdiOptions = cmdiOptions;
            this.services = [{
                    service: "runMAUSBasic",
                    title: "WebMAUS Basic",
                    sref: "interface.WebMAUSBasic",
                    shortDescription: "",
                    type: "METASERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runMAUS",
                    title: "WebMAUS General",
                    sref: "interface.WebMAUSGeneral",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runMINNI",
                    title: "WebMINNI",
                    sref: "interface.WebMINNI",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runG2P",
                    title: "G2P",
                    sref: "interface.Grapheme2Phoneme",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runCOALA",
                    title: "Coala",
                    sref: "interface.Coala",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runChunkPreparation",
                    title: "Chunk Preparation",
                    sref: "interface.ChunkPreparation",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runPho2Syl",
                    title: "Pho2Syl",
                    sref: "interface.Pho2Syl",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runTextAlign",
                    title: "TextAlign",
                    sref: "interface.TextAlign",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runChunker",
                    title: "Chunker",
                    sref: "interface.Chunker",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runPipeline",
                    title: "Pipeline without ASR",
                    sref: "interface.Pipeline",
                    shortDescription: "",
                    type: "METASERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runPipelineWithASR",
                    title: "Pipeline with ASR",
                    sref: "interface.PipelineWithASR",
                    shortDescription: "",
                    type: "METASERVICE",
                    favorite: false,
                    protected: true,
                }, {
                    service: "runASR",
                    title: "ASR",
                    sref: "interface.ASR",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: true,
                }, {
                    service: "runEMUMagic",
                    title: "EMU Magic",
                    sref: "interface.EMUMagic",
                    shortDescription: "",
                    type: "METASERVICE",
                    favorite: false,
                    protected: true,
                }, {
                    service: "runFormantAnalysis",
                    title: "Formant Analysis",
                    sref: "interface.FormantAnalysis",
                    shortDescription: "",
                    type: "METASERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runSubtitle",
                    title: "Subtitle",
                    sref: "interface.Subtitle",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runVoiceActivityDetection",
                    title: "Voice Activity Detection",
                    sref: "interface.VoiceActivityDetection",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runAnonymizer",
                    title: "Anonymizer",
                    sref: "interface.Anonymizer",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runSpeakDiar",
                    title: "SpeakDiar",
                    sref: "interface.SpeakDiar",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runAnnotConv",
                    title: "AnnotConv",
                    sref: "interface.AnnotConv",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runAudioEnhance",
                    title: "AudioEnhance",
                    sref: "interface.AudioEnhance",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runChannelSeparator",
                    title: "ChannelSeparator",
                    sref: "interface.ChannelSeparator",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "runTextEnhance",
                    title: "TextEnhance",
                    sref: "interface.TextEnhance",
                    shortDescription: "",
                    type: "SERVICE",
                    favorite: false,
                    protected: false,
                }, {
                    service: "octra",
                    title: "OCTRA",
                    href: "https://clarin.phonetik.uni-muenchen.de/apps/octra/octra/",
                    shortDescription: "OCTRA - online text transcription system.",
                    type: "EXTERNAL",
                    favorite: false,
                    protected: false,
                }, {
                    service: "wikispeech",
                    title: "WikiSpeech",
                    href: "https://webapp.phonetik.uni-muenchen.de/wikispeech/",
                    shortDescription: "WikiSpeech - content management system for the web-based creation of speech databases.",
                    type: "EXTERNAL",
                    favorite: false,
                    protected: false,
                }, {
                    service: "emuWebApp",
                    title: "EMU webApp",
                    href: "https://ips-lmu.github.io/EMU-webApp/",
                    shortDescription: "EMU webApp - online labeling of speech data and more.",
                    type: "EXTERNAL",
                    favorite: false,
                    protected: false,
                }];
            this.servicesRandomized = [];
            this.getShortDescriptionsFromCMDI();
            this.servicesRandomized = JSON.parse(JSON.stringify(this.services));
            for (var i = this.servicesRandomized.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                _a = [this.servicesRandomized[j], this.servicesRandomized[i]], this.servicesRandomized[i] = _a[0], this.servicesRandomized[j] = _a[1];
            }
            var _a;
        }
        ServiceListService.Factory = function ($http) {
            return new ServiceListService($http);
        };
        ServiceListService.prototype.annotateFavorites = function (serviceList) {
            var favorites = JSON.parse(window.localStorage.getItem('basWebServices.favoriteServices'));
            if (favorites) {
                for (var _i = 0, serviceList_1 = serviceList; _i < serviceList_1.length; _i++) {
                    var service = serviceList_1[_i];
                    if (favorites.indexOf(service.service) === -1) {
                        service.favorite = false;
                    }
                    else {
                        service.favorite = true;
                    }
                }
            }
        };
        ServiceListService.prototype.getServices = function () {
            this.annotateFavorites(this.services);
            return this.services;
        };
        ServiceListService.prototype.getServicesRandomized = function () {
            this.annotateFavorites(this.servicesRandomized);
            return this.servicesRandomized;
        };
        ServiceListService.prototype.getShortDescriptionsFromCMDI = function () {
            var _this = this;
            this.cmdiOptions.getAllServiceNames().then(function (allServiceNames) {
                var _loop_1 = function(currentServiceName) {
                    _this.cmdiOptions.getDescriptionForOperationName(currentServiceName).then(function (description) {
                        description = description.replace(/\s\s+/g, ' ');
                        var semicolonStopIndex = description.indexOf(";");
                        var fullStopIndex = description.indexOf(".");
                        var shortDescription;
                        if (semicolonStopIndex != 0 && fullStopIndex != 0 && fullStopIndex < semicolonStopIndex) {
                            shortDescription = description.substr(0, fullStopIndex) + ".";
                        }
                        else if (semicolonStopIndex != 0 && semicolonStopIndex != -1) {
                            shortDescription = description.substr(0, semicolonStopIndex) + ".";
                        }
                        else if (fullStopIndex != 0 || fullStopIndex != -1) {
                            shortDescription = description.substr(0, fullStopIndex) + ".";
                        }
                        else {
                            shortDescription = description;
                        }
                        if (_this.services.find(function (x) { return x.service === currentServiceName; })) {
                            _this.services.find(function (x) { return x.service === currentServiceName; }).shortDescription = shortDescription;
                            _this.servicesRandomized.find(function (x) { return x.service === currentServiceName; }).shortDescription = shortDescription;
                        }
                    });
                };
                for (var _i = 0, allServiceNames_1 = allServiceNames; _i < allServiceNames_1.length; _i++) {
                    var currentServiceName = allServiceNames_1[_i];
                    _loop_1(currentServiceName);
                }
            });
        };
        ServiceListService.prototype.setFavorite = function (serviceName, makeFavorite) {
            var favorites = JSON.parse(window.localStorage.getItem('basWebServices.favoriteServices'));
            if (!favorites) {
                favorites = [];
            }
            if (makeFavorite) {
                favorites.push(serviceName);
            }
            else {
                var targetIndex = favorites.indexOf(serviceName);
                if (targetIndex > -1) {
                    favorites.splice(targetIndex, 1);
                }
            }
            window.localStorage.setItem('basWebServices.favoriteServices', JSON.stringify(favorites));
        };
        return ServiceListService;
    }());
    BASWebServices.ServiceListService = ServiceListService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ServiceListService.js.map